import { IResourceComponentsProps, useNavigation, useShow } from '@pankod/refine-core'
import { QuestionUploadTableList } from 'components/uploaded_questions'
export const QuestionUploadList: React.FC<IResourceComponentsProps> = () => {
  const { show } = useNavigation()
  return <QuestionUploadTableList />
}
